export default function ColorInput({ name, value, onChange }) {
  return (
    <div className="colorPickerContainer">
      <div className="colorPreview" style={{ position: "relative" }}>
        <input
          type="color"
          value={value || ""}
          onChange={(e) => {
            onChange(name, e.target.value);
          }}
          style={{
            opacity: 0,
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            cursor: "pointer",
            zIndex: 2
          }}
        />
        <div
          className="colorBox"
          style={{
            backgroundColor: value || "",
          }}
        />
        <span className="colorValue">{value || ""}</span>
      </div>
    </div>
  );
}